import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Smartphone, Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden grain">
      <div className="aurora w-[500px] h-[500px] top-0 right-0" />
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="glass rounded-3xl p-8 w-full max-w-sm relative" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#2997FF] to-[#9852F6] flex items-center justify-center mb-5 glow-accent">
          <Smartphone className="w-6 h-6 text-white" />
        </div>
        <h1 className="font-display text-2xl font-bold">Admin Panel</h1>
        <p className="text-slate-400 text-sm mb-6">iAlış.az idarəetmə paneli</p>
        <div className="space-y-4">
          <div>
            <label className="text-sm text-slate-300 mb-1.5 block">E-poçt</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ialis.az" data-testid="login-email" className="bg-white/5 border-white/10 h-11" />
          </div>
          <div>
            <label className="text-sm text-slate-300 mb-1.5 block">Şifrə</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" data-testid="login-password" className="bg-white/5 border-white/10 h-11" />
          </div>
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="w-full mt-6 flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white text-black font-medium disabled:opacity-50 hover:bg-slate-200 transition-colors">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Daxil ol
        </button>
      </motion.form>
    </div>
  );
}
